import { useResourceGroupAggregation, formatAggregatedValue } from '../hooks/useResourceGroupAggregation';
import type { CanvasEntity } from '../entityTypes';

export function ResourceAggregationFooter({
  memberEntityIds,
  allEntities,
}: {
  memberEntityIds: string[];
  allEntities: CanvasEntity[];
}) {
  const aggregatedFields = useResourceGroupAggregation(memberEntityIds, allEntities);

  if (aggregatedFields.length === 0) return null;

  return (
    <>
      <span style={{ fontWeight: 600, color: '#475569' }}>{'\u03A3'}</span>
      {aggregatedFields.map((field, i) => (
        <span key={field.fieldId}>
          {i > 0 && <span style={{ color: '#cbd5e1', margin: '0 2px' }}>{'\u00b7'}</span>}
          <span title={`${field.key} (${field.aggregate})`}>
            {formatAggregatedValue(field)}
          </span>
        </span>
      ))}
    </>
  );
}
